module.exports = __webpack_public_path__ + "static/media/limpar.12db526c.png";